export const WIDGET_NAME = CONFIG.widget.name;
if(!WIDGET_NAME) {
    throw new Error("widget.name must defined in the config");
}